/**
 * Интерфейс для DOM элементов dropdown
 */
export interface DropdownElements {
  trigger: HTMLButtonElement
  triggerContent: HTMLElement
  triggerCount: HTMLElement
  container: HTMLElement
  optionsContainer: HTMLElement
  searchInput: HTMLInputElement
  defaultOptionButton: HTMLButtonElement
  optionButtons: HTMLButtonElement[]
}

/**
 * Класс для управления DOM элементами dropdown
 */
export class DropdownDOMManager {
  private element: HTMLElement
  private elements: DropdownElements | null = null

  /**
   * Создаёт экземпляр DropdownDOMManager
   *
   * @param {HTMLElement} element - Корневой элемент dropdown
   */
  constructor(element: HTMLElement) {
    this.element = element
  }

  /**
   * Возвращает все DOM элементы dropdown
   *
   * @return {any} Объект с всеми элементами
   */
  public getElements(): DropdownElements {
    if (this.elements) {
      return this.elements
    }

    this.elements = {
      trigger: this.element.querySelector(
        '[data-dropdown-trigger]'
      ) as HTMLButtonElement,
      triggerContent: this.element.querySelector(
        '[data-dropdown-trigger-content]'
      ) as HTMLElement,
      triggerCount: this.element.querySelector(
        '[data-dropdown-count]'
      ) as HTMLElement,
      container: this.element.querySelector(
        '[data-dropdown-container]'
      ) as HTMLElement,
      optionsContainer: this.element.querySelector(
        '[data-dropdown-options]'
      ) as HTMLElement,
      searchInput: this.element.querySelector(
        '[data-dropdown-search]'
      ) as HTMLInputElement,
      defaultOptionButton: this.element.querySelector(
        '[data-dropdown-default]'
      ) as HTMLButtonElement,
      optionButtons: Array.from(
        this.element.querySelectorAll('[data-dropdown-option]')
      )
    }

    return this.elements
  }

  /**
   * Обновляет видимость опций
   *
   * @param {Array} options - Массив опций с значениями
   */
  public updateOptionsVisibility(
    options: Array<{ value: string | number }>
  ): void {
    const elements = this.getElements()
    elements.optionButtons.forEach((button) => {
      const value = button.dataset.dropdownValue
      const optionExists = options.some((opt) => String(opt.value) === value)
      button.classList.toggle('is-hidden', !optionExists)
    })
  }
}
